<script>
	import {replace,pop} from "svelte-spa-router";
	import {documentos,cuenta} from "./store.js";
	async function actualizarDocumentos(){
		const allDocs = await db.allDocs({
			include_docs: true
		})
		$documentos = allDocs.rows.map(row => row.doc);
	}
	export async function agregarCliente(doc,n,t,e,d){
		let tiempo = new Date();
		let nuevo = {
			_id: `cliente:${doc}`,
			documento: doc,
			nombre: n,
			telefono: t,
			email: e,
			direccion: d,
			tipo: "cliente",
			creado: tiempo.valueOf()
		};
		console.log(nuevo);
		const add = await db.post(nuevo);
		if (add.ok){
			console.log(add);
			await actualizarDocumentos();
			replace(`/cliente/${doc}`);
		}
	}
	export async function editarCliente(id,rev,n,t,e,d){
		let nuevo = {
			_id: id,
			_rev: rev,
			nombre: n,
			telefono: t,
			email:e,
			direccion:d
		};
		const upd = await db.put(nuevo);
		if (upd.ok){
			await actualizarDocumentos();
			pop();
		}
	}
	export async function agregarMascota(doc,n,e,r,d,p,t,nac,owner){
		let tiempo = new Date();
		let nuevo = {
			_id: `mascota:${doc}`,
			documento:doc,
			nombre: n,
			especie: e,
			raza: r,
			detalle: d,
			peso: p,
			tamano: t,
			tipo:"mascota",
			nacimiento: nac,
			dueno: owner,
			creado: tiempo.valueOf()
		}
		const add =await db.post(nuevo);
		if (add.ok){
			await actualizarDocumentos();
			replace(`/mascota/${doc}`);
		}
	}
	export async function editarMascota(id,rev,n,d,p,t,owner){
		let nuevo = {
			_id: id,
			_rev: rev,
			nombre: n,
			detalle: d,
			peso: p,
			tamano: t,
			dueno: owner
		}
		const upd = await db.put(nuevo);
		if (upd.ok){
			await actualizarDocumentos();
			pop();
		}
	}
	export async function agregarVacuna(m,v){
		let tiempo = new Date();
		let dia = tiempo.getDate();
		let mes = tiempo.getMonth() + 1;
		let ano = tiempo.getFullYear();
		let nuevo = {
			_id:`vacuna:${m}-${dia}-${mes}-${ano}`,
			vacuna: v,
			dia: dia,
			tipo: "vacuna",
			mes: mes,
			ano: ano,
			veterinario: $cuenta.cuenta,
			mascota: m,
			creado: tiempo.valueOf()
		}
		const add = await db.post(nuevo);
		if (add.ok){
			await actualizarDocumentos();
			pop();
		}
	}
	export async function agregarHistoria(m,d,p,t,fc){
		let tiempo = new Date();
		let dia = tiempo.getDate();
		let mes = tiempo.getMonth() + 1;
		let ano = tiempo.getFullYear();
		let nuevo = {
			_id: `historia:${m}-${dia}-${mes}-${ano}`,
			tipo:"historia",
			dia: dia,
			mes: mes,
			ano: ano,
			detalle: d,
			peso: p,
			temperatura: t,
			pulsaciones: fc,
			mascota: m,
			veterinario: $cuenta.cuenta,
			creado: tiempo.valueOf()
		}
		let add = await db.post(nuevo);
		if (add.ok){
			await actualizarDocumentos();
			pop();
		}
	}

	
</script>
